module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-title ",
    class: ['title-' + theme]
  }, [_h('div', {
    staticClass: "toolbar-title ",
    class: ['toolbar-title-' + theme]
  }, [_t("default")])])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66fd03ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/src/title.vue
// module id = 160
// module chunks = 0